// @ts-nocheck
import React, { useState, useCallback, useEffect } from "react";
import { useAppSelector, useAppDispatch } from "../hooks/useRedux";
import { fetchAllPublicPosts, likePost } from "../store/postsSlice";
import PostItem from "../components/PostItem";
import PostListLoader from "../components/PostListLoader";
import SearchPanel from "../components/SearchPanel";
import { Lock, Newspaper } from "lucide-react";
import { themes } from "../Utils/Colors";
import Lottie from "lottie-react";
import loadingAnimation from "../assets/Animations/loadinganimation.json";
import Header from "./Header";
import { useNavigate } from "react-router-dom";

const PostFeedScreen = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { allPosts, loading, uploadingPosts } = useAppSelector(
    (state) => state.posts
  );
  const apiResponse = useAppSelector(
    (state) => state?.posts?.allPostsApiResponse
  );

  console.log("api response: ", apiResponse);

  const progress = uploadingPosts
    ? Object.values(uploadingPosts)[0]?.progress
    : undefined;

  const [searchText, setSearchText] = useState("");
  const [playing, setPlaying] = useState(null);

  useEffect(() => {
    dispatch(fetchAllPublicPosts());
  }, [dispatch]);

  const toggleLike = (id) => {
    dispatch(likePost(id));
  };

  const filteredPosts = allPosts?.filter((post) =>
    post?.content?.toLowerCase().includes(searchText.toLowerCase())
  );

  // Check if profile is private (or any error with message)
  const isPrivateOrRestricted =
    apiResponse && !apiResponse.success && apiResponse.message;

  return (
    <div className="flex flex-col items-center min-h-screen bg-black">
      <div className="w-full max-w-2xl">
        {loading ? (
          <PostListLoader />
        ) : (
          <>
            {/* Upload Progress */}
            {progress > 0 && progress < 100 && (
              <div className="mb-4 p-4 bg-black border border-red-700 rounded-lg shadow-md">
                <p className="text-white font-semibold mb-2">
                  Uploading Post... <span className="text-sm">{progress}%</span>
                </p>
                <div className="w-full h-5 bg-white/25 rounded-md overflow-hidden relative">
                  <div
                    className="h-full bg-white absolute top-0 left-0 flex items-center"
                    style={{ width: `${progress}%` }}
                  >
                    <Lottie
                      animationData={loadingAnimation}
                      style={{ height: 20, width: 20 }}
                      loop
                      autoplay
                    />
                  </div>
                </div>
              </div>
            )}

            {/* Show Private/Restricted Message */}
            {isPrivateOrRestricted ? (
              <div className="flex flex-col items-center justify-center py-20 px-6 text-center">
                <div className="bg-gray-900 border border-gray-800 rounded-2xl p-10 max-w-md shadow-2xl">
                  <Lock
                    className="w-20 h-20 text-gray-500 mx-auto mb-6"
                    strokeWidth={1.5}
                  />

                  <h2 className="text-2xl font-bold text-white mb-4">
                    This Profile is Private
                  </h2>

                  <p className="text-gray-300 text-base leading-relaxed mb-6">
                    {apiResponse.message}
                  </p>

                  <div className="text-sm text-gray-500 bg-gray-800 rounded-lg py-3 px-5 inline-block">
                    <span className="font-medium">To make it public:</span>
                    <br />
                    Profile → Settings → Private/Public Profile
                  </div>
                </div>
              </div>
            ) : (
              <>
                {/* Search Panel - Only show if NOT private */}
                {!isPrivateOrRestricted && (
                  <div className="px-4 mb-2">
                    {" "}
                    {/* ← Add this wrapper */}
                    <button
                      className="w-full bg-transparent p-0"
                      onClick={() => navigate("/search-screen")}
                    >
                      <SearchPanel
                        searchText={searchText}
                        setSearchText={setSearchText}
                      />
                    </button>
                  </div>
                )}

                {/* Normal Posts Feed */}
                {filteredPosts?.length === 0 ? (
                  <div className="text-center mt-20 text-gray-400">
                    <Newspaper className="w-16 h-16 mx-auto mb-4 opacity-50" />
                    <p className="text-lg">No posts yet.</p>
                    <p className="text-sm mt-2">
                      Be the first to post something!
                    </p>
                  </div>
                ) : (
                  <div className="flex flex-col items-center w-full pb-10">
                    {filteredPosts?.map((post) => (
                      <PostItem
                        key={post.post_id}
                        item={post}
                        onToggleLike={toggleLike}
                        playing={playing}
                        setPlaying={setPlaying}
                        className="w-full max-w-lg mb-4"
                      />
                    ))}
                  </div>
                )}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default PostFeedScreen;
